import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUndoRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M2.2 6.5a1 1 0 0 1 0-1L6 1.7q.5-.4 1 0 .5.6 0 1L4.6 5.3H12a5.9 5.9 0 0 1 0 11.8H4.7a.8.8 0 0 1 0-1.5h7.4a4.4 4.4 0 0 0 0-8.8H4.6L7 9.2q.5.7 0 1-.4.6-1 .1z" })
});
export default SvgUndoRegularIcon;
